// Who is offered a decision about a face (PRD-0032 SC-036).
import type { CaseRole } from '@/services/api/cases'

/**
 * Whether the face screens offer the caller their decisions: confirm, reject,
 * merge, create an identity, the reference toggle and the main photo. *role* is
 * the one the read names (`member_role`; a superuser reads as owner): a
 * collaborator and an owner decide, a viewer is offered nothing — the pure
 * components then get no callback for that part, and the surface says why.
 */
export function canDecideFaces(role: CaseRole | null | undefined): boolean {
  // No role named: an API older than the field. Nothing is withheld — it refuses
  // a viewer either way, and the surface then says so (`forbidden`).
  if (role == null) return true
  return role === 'collaborator' || role === 'owner'
}
